import axios from "axios";
import { Form, Popup, Toolbar } from "devextreme-react";
import {
  ButtonItem,
  EmptyItem,
  Label,
  SimpleItem,
} from "devextreme-react/form";
import { Item } from "devextreme-react/toolbar";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";

export default function BankInformation() {
  const [dataSource, setDataSource] = useState(null);
  const [bankDataSource, setBankDataSource] = useState(null);

  const [popupVisible, setPopupVisible] = useState(false);

  const userInfo = useSelector((state) => state.userInfo);

  useEffect(async () => {
    setSetDataSource();

    const result = await axios.get(
      `${process.env.REACT_APP_BECCO_API_URL}/api/persRcrd/salaryInfo/bankInfo`
    );

    setBankDataSource(result.data);
  }, []);

  const setSetDataSource = async () => {
    const result = await axios.get(
      `${process.env.REACT_APP_BECCO_API_URL}/api/persRcrd/salaryInfo/bankInfo/${userInfo.employeeNo}`
    );

    setDataSource(result.data);
  };

  const onHiding = () => {
    setPopupVisible(false);
  };

  const onClick = async () => {
    await axios.put(
      `${process.env.REACT_APP_BECCO_API_URL}/api/employee/${userInfo.employeeNo}`,
      dataSource
    );

    setPopupVisible(false);

    setSetDataSource();
  };

  return (
    <React.Fragment>
      <Toolbar>
        <Item
          location={"after"}
          locateInMenu="auto"
          widget={"dxButton"}
          options={{
            icon: "plus",
            onClick: () => {
              setPopupVisible(true);
            },
          }}
        />
      </Toolbar>
      {dataSource && (
        <div>
          <div className="tabpanel-item">
            <div>
              <table>
                <tbody>
                  <tr>
                    <th>예금주:</th>
                    <td>
                      <b>{dataSource.acctH}</b>
                    </td>
                  </tr>
                  <tr>
                    <th>은행:</th>
                    <td>
                      <b>
                        {bankDataSource && dataSource.bank
                          ? bankDataSource.find(
                              (item) => item.id == dataSource.bank
                            ).name
                          : null}
                      </b>
                    </td>
                  </tr>
                  <tr>
                    <th>계좌번호:</th>
                    <td>
                      <b>{dataSource.acctNo}</b>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      )}
      <Popup
        visible={popupVisible}
        dragEnabled={false}
        hideOnOutsideClick={true}
        showCloseButton={true}
        width={1200}
        height="auto"
        title="은행정보"
        onHiding={onHiding}
      >
        <Form
          labelMode="outside"
          showCloseButton={false}
          labelLocation={"top"}
          minColWidth={300}
          colCount={4}
          colCountByScreen={{ sm: 2, md: 4 }}
          screenByWidth={(width) => {
            return width < 720 ? "sm" : "md";
          }}
          validationGroup="bankInfo"
          height={"100%"}
          formData={dataSource}
        >
          <SimpleItem
            dataField={"acctH"}
            editorType="dxTextBox"
            editorOptions={{
              showClearButton: true,
            }}
          >
            <Label text={"예금주"} />
          </SimpleItem>
          <SimpleItem
            dataField={"bank"}
            editorType="dxSelectBox"
            editorOptions={{
              dataSource: bankDataSource,
              valueExpr: "id",
              displayExpr: "name",
              searchEnabled: true,
              searchMode: "contains",
              searchExpr: "name",
              minSearchLength: 0,
              showDataBeforeSearch: true,
              showClearButton: true,
            }}
          >
            <Label text={"은행"} />
          </SimpleItem>
          <SimpleItem
            dataField={"acctNo"}
            editorType="dxNumberBox"
            editorOptions={{
              showClearButton: true,
              placeholder: "숫자만 입력해주세요",
              max: 99999999999999,
            }}
          >
            <Label text={"계좌번호"} />
          </SimpleItem>
          <EmptyItem />
          <ButtonItem
            horizontalAlignment={"right"}
            buttonOptions={{
              text: "SAVE",
              type: "normal",
              stylingMode: "text",
              onClick: onClick,
            }}
            colSpan={4}
          />
        </Form>
      </Popup>
    </React.Fragment>
  );
}
